module.exports = __webpack_public_path__ + "static/CMMC_1021-1c5ec0cc3b7a56df4ee97c16322c24ae.png";